import { environment } from './../../../environments/environment';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imagePath'
})
export class ImagePathPipe implements PipeTransform {

  transform(value: string): unknown {
    if(!value)
      return "assets/images/avatar/12.svg";

    return `${environment.baseUrl}${value}`;
  }

}
